export default __webpack_public_path__ + "static/media/matrimony3.7edd86f4.jpg";